import { render } from "./Benefits.htm?vue&type=template&id=46b451b6&scoped=true"
import script from "./Benefits.js?vue&type=script&lang=js"
export * from "./Benefits.js?vue&type=script&lang=js"

import "./Benefits.scss?vue&type=style&index=0&id=46b451b6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b451b6"]])

export default __exports__